/* eslint-disable indent */
import React from "react";
import {
  Box,
  Breakpoint,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface ModalProps {
  actions: boolean;
  dataId?: any;
  title: string;
  open: boolean;
  data?: any;
  size: Breakpoint;
  closeButtonTitle?: string;
  submitButtonTitle?: string;
  description?: string;
  children?: React.ReactNode;
  onClose?: () => void;
  onConfirm?: any;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  hasTitle?: boolean;
  fullScreen?: boolean;
  headerCloseButton?: boolean;
}

export const Modal: React.FC<ModalProps> = ({
  dataId,
  title,
  open,
  size,
  children,
  closeButtonTitle = "Close",
  submitButtonTitle = "Submit",
  description,
  setOpen,
  onClose,
  actions,
  onConfirm,
  hasTitle = true,
  fullScreen,
  headerCloseButton = true,
}: ModalProps) => {
  const handleClose = () => {
    setOpen(false);
    if (onClose) onClose();
  };

  const handleConfirm = (dataId?: string) => {
    if (onConfirm) onConfirm(dataId);
    handleClose();
  };

  return (
    <Dialog
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: 4,
        },
      }}
      fullWidth
      maxWidth={size}
      open={open}
      onClose={handleClose}
      fullScreen={fullScreen}
    >
      <Box
        sx={{
          background: "#fff",
        }}
        padding={1}
      >
        {hasTitle && (
          <DialogTitle
            sx={{
              position: "sticky",
              top: 10,
              zIndex: 10,
              backgroundColor: "#fff",
              borderBottom: "1px solid #eee",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingRight: 2,
            }}
          >
            {title}
            {headerCloseButton && (
              <IconButton onClick={onClose}>
                <CloseIcon sx={{ color: "#777" }} />
              </IconButton>
            )}
          </DialogTitle>
        )}
        <DialogContent>
          <DialogContentText>{description}</DialogContentText>
          {children}
        </DialogContent>
        {actions && (
          <DialogActions>
            <Button color="primary" variant="outlined" onClick={handleClose}>
              {closeButtonTitle}
            </Button>
            <Button
              variant="contained"
              onClick={() => handleConfirm(dataId)}
              autoFocus
            >
              {submitButtonTitle}
            </Button>
          </DialogActions>
        )}
      </Box>
    </Dialog>
  );
};
